const normalizePreschoolClassToken = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const PRESCHOOL_CLASS_TOKENS = new Set([
  "prenursery",
  "pren",
  "pn",
  "nursery",
  "nursury",
  "nur",
  "nu",
  "kindergarten",
  "prekg",
  "juniorkg",
  "juniork",
  "jrkg",
  "jkg",
  "jk",
  "lkg",
  "seniorkg",
  "seniork",
  "srkg",
  "skg",
  "sk",
  "ukg",
  "kg",
]);

export const isPreschoolClass = (value = "") => {
  const classToken = normalizePreschoolClassToken(value);
  if (!classToken) return false;
  return Array.from(PRESCHOOL_CLASS_TOKENS).some((token) => classToken.includes(token));
};

export const isPreschoolUser = (user = {}) =>
  isPreschoolClass(user?.className || user?.class || user?.class_name || user?.grade || user?.standard || "");
